import { Skeleton } from 'antd';
import { t } from '@/lib/i18n';

export const PageLoading = () => (
  <div
    className="h-[60vh] px-10 py-6"
    role="status"
    aria-label={t('正在加载')}
    aria-busy="true"
  >
    <Skeleton active />
  </div>
);
